//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const AddToCartStatus = Object.freeze({
  NOT_FULLY_SPECIFIED: Symbol("NOT_FULLY_SPECIFIED"),
  NOT_IN_STOCK: Symbol("NOT_IN_STOCK"),
  IN_STOCK: Symbol("IN_STOCK"),
})

export default {
  data: function() {
    const root = document.getElementById("item-variants")
    return {
      item_code: root.dataset.itemCode,
      item_name: root.dataset.itemName,
      attrs: {},
      combinations: {},
      selected_attrs: {},
      is_loading: false,
      next_data: {},
      adding_to_cart: false,
    }
  },
  computed: {
    attrs_display: function() {
      return Object.values(this.attrs).map(a => {
        const name = a.name
        const values = a.values.map(v => {
          const disabled = this.disabled_attrs[name].has(v.val)
          return {
            value: v.val,
            label: v.label,
            display_label: a.type === "Color" ? "" : v.label,
            btn_class: [
              this.selected_attrs[name] === v.val ? "btn-success" : "btn-light",
              a.type === "Color" ? "btn-color" : ""
            ],
            btn_style: a.type === "Color" ? { backgroundColor: `#${v.code}` } : {},
            disabled,
          }
        })
        return { name, values, is_dropdown: a.is_dropdown }
      })
    },
    selected_size_attrs: function() {
      return Object.values(this.attrs)
        .filter(a => a.type === "Size")
        .map(a => {
          const selected = this.selected_attrs[a.name]
          return a.values.find(v => v.val === selected)
        })
        .filter(v => v && !!v.code )
    },
    unselected_attrs: function() {
      return Object.values(this.attrs).filter(a => this.selected_attrs[a.name] === undefined)
    },
    disabled_attrs: function() {
      const disabled_attrs = Object.keys(this.attrs).reduce((acc, cur) => { return { ...acc, [cur]: new Set() } }, {})
      for (const attr of Object.keys(this.attrs)) {
        values: for (const value of this.attrs[attr].values.map(v => v.val)) {
          const selected_attrs = { ...this.selected_attrs, [attr]: value }

          combinations: for (const c of this.combinations) {
            for (const attr of Object.keys(selected_attrs)) {
              if (c[attr] !== selected_attrs[attr]) continue combinations
            }
            continue values
          }

          disabled_attrs[attr].add(value)
        }
      }
      return disabled_attrs
    },
    add_to_cart_status: function() {
      if (Object.keys(this.attrs).length === 0 || this.unselected_attrs.length > 0 || this.is_loading) {
        return AddToCartStatus.NOT_FULLY_SPECIFIED
      }

      const { exact_match = [], product_info = {} } = this.next_data
      const has_exact_match = exact_match.length === 1
      // If adding out-of-stock items is allowed by `Shopping Cart Settings`, allow adding to cart.
      // Otherwise, make sure there is enough stock.
      const is_in_stock = (product_info && product_info.allow_items_not_in_stock) ? true : Boolean(product_info && product_info.in_stock)

      if (has_exact_match && is_in_stock) {
        return AddToCartStatus.IN_STOCK
      }

      return AddToCartStatus.NOT_IN_STOCK
    },
    add_to_cart_class: function() {
      if (this.add_to_cart_status === AddToCartStatus.NOT_FULLY_SPECIFIED) return { alert: "alert-secondary", btn: "btn-secondary" }
      if (this.add_to_cart_status === AddToCartStatus.NOT_IN_STOCK) return { alert: "alert-danger", btn: "btn-danger" }
      return { alert: "alert-success", btn: "btn-success" }
    },
    selected_item_info: function() {
      const { exact_match = [], product_info = {} } = this.next_data
      const has_exact_match = exact_match.length === 1

      if (!has_exact_match) {
        return undefined
      }

      const item_code = exact_match[0]

      if (!(product_info && product_info.price)) {
        return { item_code }
      }

      const website_discount = Boolean(product_info && product_info.price && product_info.price.website_discount)
      const discounted_price = product_info && product_info.price && product_info.price.rate_after_discount
      const price = product_info && product_info.price && product_info.price.formatted_price_sales_uom

      return { item_code, website_discount, discounted_price, price }
    },
  },
  created: async function() {
    const response = await get_attributes_and_combinations(this.item_code)
    this.attrs = response.attributes
    this.combinations = response.combinations
    // Automatically select default values for attributes with only one possible value
    this.selected_attrs = Object.values(this.attrs).reduce((acc, cur) => {
      return cur.values.length === 1 ? { ...acc, [cur.name]: cur.values[0].val } : acc
    }, {})
    this.on_attr_val_selected()
  },
  methods: {
    select_attr_val: function(attr, value) {
      const { [attr]: curr, ...rest } = this.selected_attrs
      this.selected_attrs = (value === "" || curr === value) ? rest : { ...rest, [attr]: value }
      this.on_attr_val_selected()
    },
    on_attr_val_selected: async function() {
      update_slideshow(this.attrs, this.selected_attrs)
      if (this.unselected_attrs.length > 0) {
        this.next_data = {}
        return
      }
      this.is_loading = true
      try {
        this.next_data = await get_next_attributes_and_values(this.item_code, this.selected_attrs)
      } catch (e) { }
      this.is_loading = false
    },
    add_to_cart: function() {
      if (this.add_to_cart_status === AddToCartStatus.NOT_FULLY_SPECIFIED) {
        if (this.unselected_attrs.length === 0) return
        const unselected_attr_names = this.unselected_attrs.map(a => a.attribute)
        const last = unselected_attr_names.slice(-1)
        const rest = unselected_attr_names.slice(0, -1)
        const attrs_to_select = rest.length > 0 ? `${rest.join(", ")}, And ${last}` : last
        const msg = `Please Select ${attrs_to_select}`
        frappe.msgprint(__(msg))
        return
      }
      if (this.add_to_cart_status === AddToCartStatus.NOT_IN_STOCK) {
        frappe.msgprint(__("Not in Stock"))
        return
      }

      if (this.adding_to_cart) return

      this.adding_to_cart = true
      erpnext.shopping_cart.update_cart({ item_code: this.next_data.exact_match[0], qty: 1 }).then(_r => {
        // Open Shopping Cart
        const shopping_cart_icon = document.querySelector(".shopping-cart.cart-icon")
        shopping_cart_icon.click()
      }).always(() => { this.adding_to_cart = false })
    },
    set_parent_price_visibility: function() {
      const selected_attrs_names = Object.keys(this.selected_attrs)
      const parent_price = document.getElementById("parent-price")
      if (parent_price) parent_price.hidden = selected_attrs_names.length > 0
    },
  },
  watch: {
    attrs: function (_new_val, _old_val) {
      this.set_parent_price_visibility()
    },
    selected_attrs: function (_new_val, _old_val) {
      this.set_parent_price_visibility()
    },
  },
}

async function get_attributes_and_combinations(item_code) {
  const METHOD = "erpnext.portal.product_configurator.utils.get_attributes_and_combinations"
  const resp = await frappe.call(METHOD, { item_code })
  return resp.message
}

async function get_next_attributes_and_values(item_code, selected_attributes) {
  const METHOD = "erpnext.portal.product_configurator.utils.get_next_attribute_and_values"
  const resp = await frappe.call(METHOD, { item_code, selected_attributes })
  return resp.message
}

function update_slideshow(attrs, selected_attrs) {
  const slideshow = document.getElementById("item-image-slideshow")
  if (!slideshow) return
  const preview_images = Array.from(slideshow.children[1].children)

  const is_attr_affecting_imgs_selected = Object.values(attrs).filter(a => a.affects_images && selected_attrs[a.attribute] !== undefined).length > 0

  // Set hidden state for each image
  outer: for (const img of preview_images) {
    // Images on parent item are hidden if an attribute affecting images has
    // a value selected.
    if (!img.dataset.variants) {
      img.hidden = is_attr_affecting_imgs_selected
      continue
    }

    const variants = JSON.parse(img.dataset.variants)
    for (const [k, v] of Object.entries(variants)) {
      if (Object.hasOwn(selected_attrs, k) && `${selected_attrs[k]}` !== `${v}`) {
        img.hidden = true
        continue outer
      }
    }
    img.hidden = false
  }

  const active_image_current = preview_images.filter(img => img.classList.contains("active"))[0]

  if (active_image_current && !active_image_current.hidden) return
  if (active_image_current) active_image_current.classList.remove("active")

  const active_image_candidate = preview_images.filter(img => !img.hidden)[0]

  if (!active_image_candidate) {
    const full_img = slideshow.querySelector("img")
    full_img.src = "/images/no-image.png"
  } else {
    active_image_candidate.click()
  }
}
